import PubSub from 'pubsub-js';
import { readCookie } from '../Cookie';
import { signInCheck } from '../CheckUserStatus';
import { sendEvent } from '../../../utils/dataGrinch';
import { getPageInfo } from '../../../utils/pageInfo';
import {
  gtmEventPush,
  getStoreName,
  gtmPromotionImpressions,
  gtmEventPushPLP,
  getPLPTypeOfRedirection,
  segmentEventPush,
  getProductItemPDP,
  getTrendWidgetItmSourceProps
} from '../../../modules/ga/GTMdatalayer';
import { fireAddTrackers } from '../../../utils/jioAds';
import { getTagValueFromTagEngine, getPriceLableFromTagEngine } from '../../../utils/product';
import { getVariant } from '../../../refresh/organism/ABFeature/Feature';
import { getDiscountValue } from '../../../utils/price';
import { catalogIdToStoreName } from '../../../utils';
import {
  getReleaseGA4Flag,
  getMasterGA4Flag,
  getMasterGA3Flag,
  getGA4AJIOEnable,
  getUserRelevancy,
  getPlaAdsClientID
} from '../../../refresh/selectors/featureFlagsSelector';
import { getFeatureVariant } from '../../../refresh/organism/ABFeature/Feature';
import { FLEEK_STORE } from '../../../constants/constant';
import {getValidAttributionToken, isCopilotReferrer} from '../../../utils/common'
import { storageAvailable } from '../storageAvailable';
import endpoints from '../../../modules/ajio-util/endpoints';
import { sha256Hex } from '../../../utils/products';
import { getAmplitudeExperimentVariant } from '../../../utils/amplitudeCommon';
import {isMobile} from '../../../refresh/utils/deviceTypeUtils'

export function setPlaProductInStorage(brickName, code, adsData, entity = {}) {
  if (!storageAvailable('localStorage')) return;

  const { config: { seller_id: adsSellerId, client_id: adsClientId = '' } = {} } = adsData || {};
  const PLA_PRODUCTS_STORAGE_KEY = 'osmosPlaProducts';
  const newItem = {
    code: brickName,
    seller_id: adsSellerId || entity?.seller_id || entity?.sellerId || '',
    client_id: adsClientId,
    productCode: code
  };
  try {
    const existingItems = JSON.parse(localStorage.getItem(PLA_PRODUCTS_STORAGE_KEY) || '[]');
    const itemsArray = Array.isArray(existingItems) ? existingItems : [];
    const alreadyExists = itemsArray.some(item => item.code === brickName);
    const updatedItems = alreadyExists ? itemsArray : [...itemsArray, newItem];

    localStorage.setItem(PLA_PRODUCTS_STORAGE_KEY, JSON.stringify(updatedItems));
  } catch (err) {
    // fallback if storage is corrupted
    localStorage.setItem(PLA_PRODUCTS_STORAGE_KEY, JSON.stringify([newItem]));
  }
}

function trackProductItemClick({
  position = -1,
  code = -1,
  price: { formattedValue: formattedPriceValue = '', value: priceValue = '' } = {},
  discountPercent = '',
  location = {},
  entity = {},
  showPlpExtendedBanner = false,
  pageTypeCard = '',
  fromVideoBanner = false,
  toggleView = false,
  fromFloatingWidget = false,
  averageRating,
  ratingCount = '',
  freeTextSearch,
  sourcePage = false,
  jioAdsSource = false,
  store = '',
  gwpDimension,
  isComingSoonProduct=false,
  previousSource,
  enablePriorityDeliveryPhase2 = false,
  enableRushDelivery = false,
  deliveryDateAndTimeTag = '',
  enablePlpIntervention = false,
  interventionText = '',
  newProductTagEngineValue,
  isQuickView = false,
  osmosClientId
}) {
  const {
    brandName = '',
    outfitPictureURL,
    exclusiveTill: exclusiveValue = '',
    allPromotions,
    colorGroup = code
  } = entity.fnlColorVariantData;
  const jioadsBannerName = localStorage.getItem('jioadsBannerName');
  const jioadsCmpId = localStorage.getItem('jioadsCmpId');
  const {
    adsData,
    tags: { categoryTags = [] } = {},
    catalog = '',
    catalogName = '',
    segmentId = '',
    experimentId = '',
    brickName='',
  } = entity;
  const productTagEngineValue = newProductTagEngineValue || getTagValueFromTagEngine(categoryTags);
  const productPriceLabel = getPriceLableFromTagEngine(categoryTags);
  const { config: { c: campaignId, seller_id, client_id='', uclid='' } = {} } = adsData || {};
  const eventObj = {};
  eventObj.ProductPosition = position;
  eventObj.ProductId = code;
  eventObj.Price = formattedPriceValue;
  eventObj.Discount = discountPercent;

  const { pathname = '' } = location;
  const { pageId, pageType, pageCategory } = getPageInfo(pathname);
  eventObj.PageId = pageId;
  eventObj.PageType = pageType;
  eventObj.PageCategory = pageCategory;

  const PLA_PRODUCTS_STORAGE_KEY = 'osmosPlaProducts';

  if (storageAvailable('localStorage')) {
      const newItem = {
        code: brickName,
        seller_id: seller_id ? seller_id : entity?.seller_id || entity?.sellerId || "",
        client_id: client_id,
        productCode: code,
      };
    try {
      const existingItems = JSON.parse(localStorage.getItem(PLA_PRODUCTS_STORAGE_KEY) || '[]');

      const updatedItems = Array.isArray(existingItems)
        ? existingItems.some(item => item.code === brickName)
          ? existingItems
          : [...existingItems, newItem]
        : [newItem];

      localStorage.setItem(PLA_PRODUCTS_STORAGE_KEY, JSON.stringify(updatedItems));
    } catch (err) {
      // fallback if storage is corrupted
      localStorage.setItem(PLA_PRODUCTS_STORAGE_KEY, JSON.stringify([newItem]));
    }
  }


  if (!window.JioAds) {
    console.log('JioAds not initialiazed');
  }
  const jioAdsCid = sessionStorage.getItem('jioads-cid');
  if (
    jioAdsCid &&
    (window.location.href.includes('ref=banner') ||
      window.location.href.includes('ref=cmsBanner')) &&
    window.JioAds &&
    window.JioAds.fireConversionApi
  ) {
    const options = {
      revenue: priceValue,
      currency: 'INR',
      prdrevenue: priceValue,
      prdcount: 1,
      prdprice: entity.wasPriceData?.value,
      prdid: entity.code.substr(0, entity.code.length - 3)
    };
    try {
      window.JioAds.fireConversionApi(jioAdsCid, 4, options);
      console.log('Conversion Fired with data, ', options);
    } catch (error) {
      console.log('Error in conversion api', error);
      console.log('Error JIO sdk ', options);
    }
  } else {
    console.log('Conversion not fired');
  }

  // Fire OSMOS product click tracker
  const enablePlaOnPLP = getAmplitudeExperimentVariant('enable-pla-on-plp-osmos', window?.__PRELOADED_STATE__);

  if (enablePlaOnPLP && entity?.adsData) {
    try {
      const event_time = Date.now(); 
      const clickTrackerUrl = new URL(endpoints.get('osmosClickTracker'));
      const cli_ubid = signInCheck() ? sha256Hex(readCookie('CI')) || '' : sha256Hex(readCookie('segment_device_id')) || '';
      const paramsToAdd = {
        client_id: client_id ||  getPlaAdsClientID(window?.__PRELOADED_STATE__) ||'',
        cli_ubid: cli_ubid,
        uclid: uclid || '',
        event_time: event_time.toString(),
        position,
        os_name: isMobile() ? 'm_web' : 'Desktop',
      };
      Object.entries(paramsToAdd).forEach(([key, value]) => {
        if (value !== undefined && value !== '') {
          clickTrackerUrl.searchParams.set(key, value);
        }
      });
      fetch(clickTrackerUrl.toString(), {
        method: 'GET',
        headers: {
          'accept': 'application/json'
        }
      })
        .then(() => {
          console.log('OSMOS product click tracker fired successfully 🚀');
        })
        .catch(err => {
          console.log('OSMOS product click tracker failed', err);
        });
    } catch (error) {
      console.log('Error firing OSMOS product click tracker', error);
    }
  }

  sendEvent('ProductClicked', eventObj);
  gtmEventPush({
    event: 'plp_product_click',
    product_name: entity.name,
    product_id: entity.code.substr(0, entity.code.length - 3),
    product_color: colorGroup.split('_')[1],
    product_brand: brandName,
    product_position: position,
    product_price: priceValue,
    product_discount: discountPercent,
    page_type: 'Product Listing Page'
  });
  const discount =
    Number.isInteger(entity.wasPriceData?.value) && Number.isInteger(entity.price?.value)
      ? entity.wasPriceData.value - entity.price.value
      : '';
  const variantFallBack =
    colorGroup && colorGroup?.includes && colorGroup.includes('_')
      ? colorGroup.split('_')[1] || ''
      : '';

  const dimension161 = campaignId || '';
  const dimension162 = campaignId ? 'yes' : 'no';
  const dimension163 = colorGroup;

  let dimension59Data = '';
  const isWishlistPage = pageType?.toLowerCase() === 'wishlist';
  if (isWishlistPage) {
    const stockInfo = entity?.stockInfo || {};
    const availableQuantityData = (entity?.variantOptions ?? []).reduce((acc, el) => {
      acc = el?.stock?.stockLevel ?? 0;
      return acc;
    }, 0);
    const oosReason = stockInfo?.stockErrorDescription
      ? `|${stockInfo?.stockErrorDescription}`
      : '';
    dimension59Data = `${availableQuantityData}|${
      availableQuantityData ? 'deliverable' : 'non-deliverable'
    }${oosReason}`;
  }
  const storeName = getStoreName();
  const fleek = String(storeName).toLowerCase() === FLEEK_STORE.toLowerCase();
  const queryString = window.location.search;
  const urlParams = new URLSearchParams(queryString);
  const brandPageCode = urlParams.get('brandPageCode');
  const isCuratedWidget = urlParams.get('isCuratedWidget');
  const isDynamicWidget = urlParams.get('isDynamicWidget');
  const dynamicWidgetHeading = urlParams.get('heading');
  const widgetName = urlParams.get('widgetName');
  const optionName = urlParams.get('optionName');
  const plp_source_details = urlParams.get('plp_source_details');
  const sourcePageReferrer = urlParams.get('referrer');
  
  const segmentPageName =
    sourcePageReferrer === 'fleek_curated_plp_screen' ? 'fleek curated plp screen ' : 'plp screen';
  const dimension60Data =
    Number(segmentId) || Number(experimentId) ? `${segmentId}|${experimentId}` : '';
  let dimension166 =
    pageTypeCard !== 'wishlist' && getVariant('enable_urgency_driver_plp') ? productPriceLabel : '';
  if (gwpDimension) dimension166 = dimension166 ? `${dimension166}, ${gwpDimension}` : gwpDimension;

  if (enableRushDelivery || enablePriorityDeliveryPhase2)
    dimension166 = dimension166
      ? `${dimension166}, ${deliveryDateAndTimeTag}`
      : deliveryDateAndTimeTag;
  const userRelevancyFlag = getUserRelevancy(window?.__PRELOADED_STATE__?.flags);
  const ga4AjioEnable = getGA4AJIOEnable(window?.__PRELOADED_STATE__?.flags);
  let isDressTool=false;
    let dressToolSessionData;
    if(window?.location.search?.includes("dressTool")){
      isDressTool=true;
      let tempDressToolSessionData = sessionStorage.getItem('dressToolIngressDetails') || {};
      if(tempDressToolSessionData){
        dressToolSessionData = JSON.parse(tempDressToolSessionData);
      }
    }
  const previousSourceValue = window.location.pathname?.includes('/search')
    ? `|${previousSource}`
    : '';
  if (ga4AjioEnable) {
      let productStickerName = '';

      if (isComingSoonProduct) {
        productStickerName = 'COMING SOON';
      } else if (pageTypeCard !== 'wishlist' && getVariant('enable_urgency_driver_plp')) {
        productStickerName = productTagEngineValue;
      } 

    if(enablePlpIntervention){
     productStickerName = [productStickerName, interventionText].filter(Boolean).join(',')
    }

    const validToken = getValidAttributionToken()
    
    const itemListName = fleek
      ? `fleek_${brandPageCode ? `b_${brandName} ${freeTextSearch}` : `m_${freeTextSearch}`}`
      : fromFloatingWidget
      ? 'video floating widget banner plp'
      : fromVideoBanner
      ? 'video banner plp'
      : jioadsCmpId !== null
      ? 'jio ads banner plp screen'
      : isCuratedWidget
      ? `curated_widget_${widgetName}_${optionName}`
      : pageType;
      const newObjForGTM={
        event: 'select_item',
        plp_source_details: isCopilotReferrer() ? 'ai_assistant_widget' :
          jioadsCmpId !== null
            ? `jioads - ${jioadsBannerName} - ${jioadsCmpId}`
            : isCuratedWidget
            ? `curated_widget_${widgetName}_${optionName}`
            : isDressTool ? (dressToolSessionData && dressToolSessionData?.BannerName ? dressToolSessionData?.BannerName : '') :  sourcePageReferrer === 'fleek_curated_plp_screen' ? plp_source_details : isDynamicWidget ? `dynamic_${dynamicWidgetHeading}` : '',
        plp_source: jioadsCmpId !== null ? 'jio ads' : (isCuratedWidget || isDynamicWidget) ? 'widget' : isDressTool ? 'bra_dress tool' : sourcePageReferrer === 'fleek_curated_plp_screen' ? 'pdp screen  -visit ajiogram store' : '',
        plp_page_title: freeTextSearch,
          event_category: 'Enhance E-commerce',
          event_action: 'select_item',
        isGA4: true,
        ecommerce: {
          item_list_name:  sourcePageReferrer === 'fleek_curated_plp_screen' ? 'fleek_visit_ajiogram_store' : itemListName,
          items: [
            {
              item_id: entity?.fnlColorVariantData?.colorGroup?.split('_')[0],
              item_name: entity.name,
              index: Number(position) || 0,
              item_brand: brandName,
              item_list_name: itemListName,
              item_category: pageCategory,
              price: Number(entity.price?.value) || Number(formattedPriceValue) || 0,
              discount: Number(entity.wasPriceData?.value - entity.price?.value) || 0,
              coupon: '',
              quantity: 1,
              item_variant: entity?.fnlColorVariantData?.colorGroup?.split('_')[1] || colorGroup,
              product_id: entity?.fnlColorVariantData?.colorGroup?.split('_')[0] + "_" + (entity?.fnlColorVariantData?.colorGroup?.split('_')[1] || colorGroup),
              product_name: entity.name,
              product_category: entity.fnlProductData?.planningCategory,
              product_store_type: entity?.productListType 
                ? `${catalogIdToStoreName(catalog || catalogName)}|${entity.productListType}`
                : catalogIdToStoreName(catalog || catalogName),

              product_view_type:
                pageType !== 'wishlist' && toggleView ? (toggleView == 1 ? 'list' : 'grid') : '',
              available_quantity_deliverable_non_deliverable: isWishlistPage ? dimension59Data : '',
              segment_id_experiment_id: dimension60Data,
              jio_ads_campaign_data: campaignId || '',
              prod_jio_ads_listing: campaignId ? 'yes' : 'no',
              jio_ads_option_code: colorGroup,
              sticker_name: productStickerName,
              offer_name: dimension166,
              ...(validToken && {
                search_attribution: validToken
              }),

              wishlish_count: '',
              product_discount: getDiscountValue(discountPercent),
              ...(averageRating && { ratings_shown_no_of_users: `${averageRating}|${ratingCount}` })
            }
          ]
        },
        page_type: sourcePageReferrer === 'fleek_curated_plp_screen' ? 'fleek curated plp screen ':'plp screen',
        page_name: sourcePageReferrer === 'fleek_curated_plp_screen' ? 'fleek curated plp screen ':'',
        banner_theme_extended: showPlpExtendedBanner ? 'yes' : 'no',
        pricing_cust_seg: readCookie('cohortSegment') || '',
        type_of_redirection: `${getPLPTypeOfRedirection(pathname || '')} ${previousSourceValue}`,
        search_term: freeTextSearch || '',
        user_search_term: freeTextSearch || ''
      };
      if(isDressTool){
        newObjForGTM.dress_tool_ingress = (dressToolSessionData && dressToolSessionData?.IngressPoint ? dressToolSessionData?.IngressPoint : '');
      }
    gtmEventPush(
      newObjForGTM,
      catalogIdToStoreName(catalog || catalogName)
    );
   
    
    const newObjForSegment={
      event: isQuickView ? 'Quick View Product Clicked' : 'Product Clicked',
      screen_source: jioadsCmpId !== null ? 'jio ads' : isCuratedWidget ? 'widget' : isDressTool ? 'bra_dress tool' : sourcePageReferrer === 'fleek_curated_plp_screen' ? 'pdp screen  -visit ajiogram store' : 'pdp screen',
      screen_title: freeTextSearch,     
      ecommerce: {       
        items: [
          {
            product_position: Number(position) || 0,
            product_brand: brandName,            
            catalog_id : entity.catalogName,
            product_mrp: Number(entity.wasPriceData?.value) || 0,
            product_list_price: Number(entity.price?.value) || 0,
            product_offer_price: Number(entity.offerPrice?.value)  || 0,
            product_rating: entity.averageRating,
            product_id: entity?.fnlColorVariantData?.colorGroup,
            product_name: entity.name,
            product_brick: entity.fnlProductData?.planningCategory,
            offer_name: dimension166,
            product_gift_with_purchase_flag: entity?.offerPrice?.giftAvailable ?? false
          }
        ]
      },
      screen_name: segmentPageName,
      page_name: segmentPageName,
      type_of_redirection: `${getPLPTypeOfRedirection(pathname || '')} ${previousSourceValue}`,
      search_term: freeTextSearch || '',    
    };  
   

  } else {
    gtmEventPush(
      {
        event: 'ee_product_click',
        plp_source_details:
          jioadsCmpId !== null
            ? `jioads - ${jioadsBannerName} - ${jioadsCmpId}`
            : isCuratedWidget
            ? `curated_widget_${widgetName}_${optionName}`
            : '',
        plp_source: jioadsCmpId !== null ? 'jio ads' : isCuratedWidget ? 'widget' : '',
        plp_page_title: freeTextSearch,
        ecommerce: {
          currencyCode: 'INR',
          click: {
            actionField: {
              list: fleek
                ? `fleek_${
                    brandPageCode ? `b_${brandName} ${freeTextSearch}` : `m_${freeTextSearch}`
                  }`
                : fromFloatingWidget
                ? 'video floating widget banner plp'
                : fromVideoBanner
                ? 'video banner plp'
                : jioadsCmpId !== null
                ? 'jio ads banner plp screen'
                : isCuratedWidget
                ? `curated_widget_${widgetName}_${optionName}`
                : pageType
            },
            products: [
              {
                name: entity.name,
                id: entity?.fnlColorVariantData?.colorGroup,
                price: entity.price?.value || formattedPriceValue,
                brand: brandName,
                list: fleek
                  ? `fleek_${
                      brandPageCode ? `b_${brandName} ${freeTextSearch}` : `m_${freeTextSearch}`
                    }`
                  : isCuratedWidget
                  ? `curated_widget_${widgetName}_${optionName}`
                  : jioadsCmpId !== null
                  ? 'jio ads banner plp screen'
                  : '',
                position,
                variant: entity?.fnlColorVariantData?.colorGroup?.split('_')[1] || colorGroup,
                category: pageCategory,
                dimension12: entity?.fnlColorVariantData?.colorGroup?.split('_')[0],
                dimension13: entity.name,
                dimension14: '',
                dimension15: entity.fnlProductData?.planningCategory,
                dimension16: entity.fnlProductData?.planningCategory,
                dimension20: '',
                dimension21: brandName,
                dimension22: priceValue,
                dimension23: catalogIdToStoreName(catalog || catalogName),
                dimension24: '',
                dimension41:
                  pageType !== 'wishlist' && toggleView ? (toggleView == 1 ? 'list' : 'grid') : '',
                dimension59: isWishlistPage ? dimension59Data : '',
                dimension60: dimension60Data,
                dimension161: campaignId || '',
                dimension162: campaignId ? 'yes' : 'no',
                dimension163: colorGroup,
                dimension165:
                  pageTypeCard !== 'wishlist' && getVariant('enable_urgency_driver_plp')
                    ? productTagEngineValue
                    : '',
                dimension166,
                dimension167: '',
                dimension170: getDiscountValue(discountPercent),
                ...(averageRating && { dimension46: `${averageRating}|${ratingCount}` })
              }
            ]
          }
        },
        page_type: 'plp screen',
        banner_theme_extended: showPlpExtendedBanner ? 'yes' : 'no',
        pricing_cust_seg: readCookie('cohortSegment') || ''
      },
      catalogIdToStoreName(catalog || catalogName)
    );
  }

   const trendTag = entity?.trends?.positions?.[0]?.tag?.[0]?.tagName || '';
   const productEntity = { ...entity, osmosClientId, ...{
      product_tag : trendTag ? `${productTagEngineValue}|||${trendTag}` : productTagEngineValue,
      campaignId : campaignId,
      priority_delivery_edd : dimension166
    }}
    const newObjForSegment={
    event: isQuickView ? 'Quick View Product Clicked' : 'Product Clicked',
    ...getTrendWidgetItmSourceProps(),
          screen_source: jioadsCmpId !== null ? 'jio ads' : isCuratedWidget ? 'widget' : isDressTool ? 'bra_dress tool' : sourcePageReferrer === 'fleek_curated_plp_screen' ? 'pdp screen  -visit ajiogram store' : 'pdp screen',
      screen_title: freeTextSearch,
      impression_source : jioadsCmpId !== null
           ? `jioads - ${jioadsBannerName} - ${jioadsCmpId}`
           : isCuratedWidget
           ? `curated_widget_${widgetName}_${optionName}`
           : isDressTool ? (dressToolSessionData && dressToolSessionData?.BannerName ? dressToolSessionData?.BannerName : '') :  sourcePageReferrer === 'fleek_curated_plp_screen' ? plp_source_details : '',
      impression_type: 'Vertical',
      ecommerce: {       
        items: [
          getProductItemPDP(productEntity, Number(position) || 0, campaignId)
        ]
      },
      screen_name: segmentPageName,
      page_name: segmentPageName,
      type_of_redirection: `${getPLPTypeOfRedirection(pathname || '')} ${previousSourceValue}`,
      search_term: freeTextSearch || '',      
    };
      
    segmentEventPush(newObjForSegment,
      catalogIdToStoreName(catalog || catalogName)
    );

  localStorage.removeItem('jioadsBannerName');
  localStorage.removeItem('jioadsCmpId');
  fireAddTrackers([entity], 'click');
  return true;
}

function trackProductItemHover({
  position = -1,
  code = -1,
  price: { formattedValue: formattedPriceValue = '' } = {},
  discountPercent = '',
  location = {},
  entity = {},
  pageTypeCard = '',
  freeTextSearch,
  previousSource,
  newProductTagEngineValue
}) {
  const jioadsBannerName = localStorage.getItem('jioadsBannerName');
  const jioadsCmpId = localStorage.getItem('jioadsCmpId');
  const { adsData, tags: { categoryTags = [] } = {}, catalog = '', catalogName = '' } = entity;
  const productTagEngineValue = newProductTagEngineValue || getTagValueFromTagEngine(categoryTags);
  const productPriceLabel = getPriceLableFromTagEngine(categoryTags);
  const { config: { c: campaignId } = {} } = adsData || {};
  const eventObj = {};
  eventObj.ProductPosition = position;
  eventObj.ProductId = code;
  eventObj.Price = formattedPriceValue;
  eventObj.Discount = discountPercent;

  const { pathname = '' } = location;
  const { pageId, pageType, pageCategory } = getPageInfo(pathname);
  eventObj.PageId = pageId;
  eventObj.PageType = pageType;
  eventObj.PageCategory = pageCategory;

  const dimension166 =
    pageTypeCard !== 'wishlist' && getVariant('enable_urgency_driver_plp') ? productPriceLabel : '';

  let isDressTool = false;

  const queryString = window.location.search;
  const urlParams = new URLSearchParams(queryString);

  let dressToolSessionData;
  if (queryString?.includes('dressTool')) {
    isDressTool = true;
    const tempDressToolSessionData = sessionStorage.getItem('dressToolIngressDetails') || {};
    if (tempDressToolSessionData) {
      dressToolSessionData = JSON.parse(tempDressToolSessionData);
    }
  }

  const widgetName = urlParams.get('widgetName');
  const optionName = urlParams.get('optionName');
  const plpSourceDetails = urlParams.get('plp_source_details');
  const isCuratedWidget = urlParams.get('isCuratedWidget');
  const sourcePageReferrer = urlParams.get('referrer');

  const previousSourceValue = window.location.pathname?.includes('/search')
    ? `|${previousSource}`
    : '';
  const segmentPageName =
    sourcePageReferrer === 'fleek_curated_plp_screen' ? 'fleek curated plp screen ' : 'plp screen';

  const productEntity = {
    ...entity,
    ...{
      product_tag: productTagEngineValue,
      campaignId: campaignId,
      priority_delivery_edd: dimension166
    }
  };
  const newObjForSegment = {
    event: 'Quick View Product Viewed',
    screen_source:
      jioadsCmpId !== null
        ? 'jio ads'
        : isCuratedWidget
        ? 'widget'
        : isDressTool
        ? 'bra_dress tool'
        : sourcePageReferrer === 'fleek_curated_plp_screen'
        ? 'pdp screen  -visit ajiogram store'
        : 'pdp screen',
    screen_title: freeTextSearch,
    impression_source:
      jioadsCmpId !== null
        ? `jioads - ${jioadsBannerName} - ${jioadsCmpId}`
        : isCuratedWidget
        ? `curated_widget_${widgetName}_${optionName}`
        : isDressTool
        ? dressToolSessionData && dressToolSessionData?.BannerName
          ? dressToolSessionData?.BannerName
          : ''
        : sourcePageReferrer === 'fleek_curated_plp_screen'
        ? plpSourceDetails
        : '',
    impression_type: 'Vertical',
    ecommerce: {
      items: [getProductItemPDP(productEntity, Number(position) || 0, campaignId)]
    },
    screen_name: segmentPageName,
    page_name: segmentPageName,
    type_of_redirection: `${getPLPTypeOfRedirection(pathname || '')} ${previousSourceValue}`,
    search_term: freeTextSearch || ''
  };

  segmentEventPush(newObjForSegment, catalogIdToStoreName(catalog || catalogName));
}

export function trackRemoveItemFromWishList({
  code = -1,
  price: { formattedValue: formattedPriceValue = '' } = {},
  location = {}
}) {
  const eventObj = [];
  eventObj.ProductId = code;
  eventObj.Price = formattedPriceValue;

  const { pathname = '' } = location;
  const { pageId, pageType, pageCategory } = getPageInfo(pathname);
  eventObj.PageId = pageId;
  eventObj.PageType = pageType;
  eventObj.PageCategory = pageCategory;

  sendEvent('DeleteCloset', eventObj);
  return true;
}

function trackFetchProduct(params, event) {
  let eventObj = [];
  const { pathname = '' } = location;
  let { pageId, pageType, pageCategory } = getPageInfo(pathname);
  const { request: { query: { text = '' } = {}, totalResults = 0 } = {} } = params;

  if (params.endOfPage) {
    eventObj = { ...eventObj, endOfPage: params.endOfPage, endofProductResult: params.endOfPage };
  }

  if (totalResults) {
    eventObj['No.OfProducts'] = totalResults;
  }

  eventObj.PageType = pageType;
  eventObj.PageCategory = pageCategory;
  if (pathname.includes('search')) {
    pageId = !pageId && text ? text : '';
  }

  const {
    request: {
      query: { sortBy = '', facets = '' } = {},
      curatedQuery: { facets: curatedFacets = '' } = {}
    } = {}
  } = params;
  let currentFacets = facets;
  eventObj.PageId = pageId;

  // eventObj["SortValue"] = sortBy;

  if (curatedFacets.length) {
    currentFacets = facets.split(curatedFacets)[1];
  }
  if (currentFacets) {
    eventObj.facets = currentFacets;
  }

  sendEvent(event, eventObj);
  return true;
}

PubSub.subscribe('PLP-API-RESPONSE', (message, data) => {
  const { request = {} } = data;
  let obj = {
    request
  };

  if (data.endOfPage) {
    obj = { ...obj, endOfPage: data.endOfPage };
  }
  trackFetchProduct(obj);
});
export { trackProductItemClick, trackFetchProduct, trackProductItemHover };
